/**
 * Handles document name renaming.
 * The document names we have in our system are not the colloquial names our
 * customers know, so we need to rename the documents before presentation.
 * @param documentType - The document type to transform.
 */
export const renameDocuments = (documentType?: string) => {
  if (!documentType) return '';
  if (documentType.toLowerCase() === 'land use redesignation') return 'Rezoning';
  if (documentType.toLowerCase() === 'electrical inspection') return 'Electrical Permit';
  if (documentType.toLowerCase() === 'development permit') return 'Site Plan';

  return documentType;
};
